module.exports = __webpack_public_path__ + "img/MOVE.7f237ca5.svg";